import React, { PureComponent } from 'react';
import { Marker } from 'react-google-maps';

import { MARKER_STYLES } from 'shared/constants/map';
import { toGoogleCoordinates } from 'shared/helpers/coordinates';
import { getSymbolUrl } from 'shared/helpers/map';
import { MapInfoWindow } from 'shared/components/presentational/Map';
import { COLORS } from 'shared/constants/theme';
import MapShopDetails from './MapShopDetails';

export default class MapShopMarker extends PureComponent {
  render() {
    const {
      shop,
      isSelected,
      isLoading,
      onMarkerClick: handleMarkerClick,
      onInfoWindowClose: handleInfoWindowClose,
      handleDirections,
      directionsPending,
      t
    } = this.props;
    const { latitude, longitude, type } = shop;

    return (
      <Marker
        noRedraw
        icon={{
          ...MARKER_STYLES,
          url: getSymbolUrl(type, isSelected ? COLORS.valencia : COLORS.black)
        }}
        position={toGoogleCoordinates({ latitude, longitude })}
        onClick={() => handleMarkerClick(shop)}
      >
        {isSelected && (
          <MapInfoWindow
            onCloseClick={handleInfoWindowClose}
            itemScope
            itemType="http://schema.org/Store"
          >
            <MapShopDetails
              shop={shop}
              isLoading={isLoading}
              onActionClick={handleDirections}
              actionPending={directionsPending}
              t={t}
            />
          </MapInfoWindow>
        )}
      </Marker>
    );
  }
}
